import { render, staticRenderFns } from "./payments-badge-state.vue?vue&type=template&id=356af29c&"
import script from "./payments-badge-state.vue?vue&type=script&lang=js&"
export * from "./payments-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports